import React from "react";

import { ButtonStandard, Text } from "@performyard/py-components";

import ContentModal from "../../../../../components/Modal/Templates/ContentModal";

type CalendarDisconnectionModalProps = {
	isOpen: boolean;
	isDisconnecting: boolean;
	handleConfirmDisconnect: () => void;
	handleCancelDisconnect: () => void;
};

export const CalendarDisconnectionModal = ({
	isOpen,
	isDisconnecting,
	handleConfirmDisconnect,
	handleCancelDisconnect,
}: CalendarDisconnectionModalProps) => {
	return (
		<ContentModal
			isOpen={isOpen}
			handleClose={handleCancelDisconnect}
			size="large"
			title={
				<Text weight="semi-bold" size="sub-heading">
					Disconnect Calendar?
				</Text>
			}
			buttons={[
				<ButtonStandard
					key="cancel"
					color="primary"
					onClick={handleCancelDisconnect}
					size="large"
					disabled={isDisconnecting}
				>
					Cancel
				</ButtonStandard>,
				<ButtonStandard
					key="disconnect"
					color="red"
					onClick={handleConfirmDisconnect}
					size="large"
					disabled={isDisconnecting}
				>
					Yes, Disconnect
				</ButtonStandard>,
			]}
		>
			<Text weight="regular" size="paragraph-2" dangerouslySetClassName="text-center">
				Do you really want to disconnect this calendar? If you do, you&apos;ll need to reconnect it later to use
				it again.
			</Text>
		</ContentModal>
	);
};
